<script>
import { Line } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);
export default {
  extends: Line,
  props: {
    labelsData: {
      type: Array,
      required: true,
    },
    chartData: {
      type: Array,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        tension: 0.4,
      }),
    },
  },
  methods: {
    renderChartLayout() {
      this.renderChart(
        {
          labels: this.labelsData,
          datasets: this.chartData,
        },
        this.chartOptions
      );
    },
  },
  watch: {
    labelsData: "renderChartLayout",
    chartData: {
      handler: "renderChartLayout",
      deep: true,
    },
  },

  mounted() {
    this.renderChartLayout();
  },
};
</script>
